import { Box, Link, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { ArrowCaretDown } from "../../../icons";
import { Link as LinkRouter, useLocation } from "react-router-dom";
import HoverPopover from "material-ui-popup-state/HoverPopover";
import {
  bindHover,
  bindPopover,
  usePopupState,
} from "material-ui-popup-state/hooks";
import React from "react";
import { CircleHover } from "./CircleHover";

type ItemMenuPcProps = {
  label?: string;
  menulabel?: string;
  to?: string;
  children?: React.ReactNode;
};

const getStyle = (theme: Theme) => {
  const iconButton: SxProps<Theme> = {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    position: "relative",
    transition: "0.2s ease",
    gap: 1,
    paddingBlock: 5.5,
    "&:hover": { backgroundColor: "transparent" },
  };
  const label: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    textWrap: "nowrap",
    textDecoration: "none",
    position: "relative",
    textTransform: "capitalize",
  };

  const visibleHover: SxProps<Theme> = {
    "&:hover .circle-hover": {
      opacity: 1,
      scale: 1,
    },
  };
  const visible: SxProps<Theme> = {
    ".circle-hover": {
      opacity: 1,
      scale: 1,
    },
  };

  return { iconButton, visibleHover, visible, label };
};

export const ItemMenuPc = ({
  label,
  menulabel,
  to,
  children,
}: ItemMenuPcProps) => {
  const theme = useTheme();
  const styles = getStyle(theme);
  const location = useLocation();
  const circleActive =
    to === location.pathname ? styles.visible : styles.visibleHover;
  const labelActive =
    to === location.pathname
      ? theme.palette.primary[600]
      : theme.palette.secondary.main;

  const popupState = usePopupState({
    variant: "popper",
    popupId: "demoPopover",
  });

  return (
    <>
      {label ? (
        <Box sx={[styles.label, circleActive]}>
          <CircleHover />
          <Link
            component={LinkRouter}
            variant="body2"
            color="secondary"
            style={{
              color: labelActive,
            }}
            to={to ?? ""}
            sx={styles.label}
          >
            {label}
          </Link>
        </Box>
      ) : (
        <>
          <Box
            {...bindHover(popupState)}
            sx={[styles.iconButton, popupState.isOpen && styles.visible]}
          >
            <CircleHover />

            <Typography
              variant="body2"
              color="secondary"
              sx={[styles.label, circleActive]}
            >
              {menulabel}
            </Typography>

            <ArrowCaretDown
              className="arrow-down"
              sx={{
                width: 10,
                height: 10,
                transition: "transform 0.2s ease",
                transform: popupState.isOpen
                  ? "rotate(-180deg)"
                  : "rotate(0deg)",
              }}
            />
          </Box>
          <HoverPopover
            {...bindPopover(popupState)}
            disableScrollLock={true}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  position: "absolute",
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: 15,
                  borderBottomRightRadius: 15,
                  backgroundColor: theme.palette.background.paper,
                  backdropFilter: "saturate(180%) blur(35px)",
                },
              },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <Box
              onClick={(e) => {
                const target = e.target as HTMLElement;
                if (target.closest(".cerrar-popover")) {
                  popupState.close();
                }
              }}
            >
              {children}
            </Box>
          </HoverPopover>
        </>
      )}
    </>
  );
};
